// Investment trust fund management: the routes and the sidebar rows of `dowgate.intelligence.fund-management` (ADR-0027).
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const ViewFundTrustDetailPage = lazy(() => import('@/pages/view/fund-management/trust/page'));

export default defineWebFeature({
    id: 'dowgate.intelligence.fund-management',
    routes: [
        {
            frontend: 'view',
            path: 'fund-management',
            lazy: () => import('@/pages/view/fund-management/page'),
        },
        {
            frontend: 'view',
            path: 'fund-management/:trustId',
            element: <ViewFundTrustDetailPage screen="dashboard" />,
        },
        {
            frontend: 'view',
            path: 'fund-management/:trustId/policy',
            element: <ViewFundTrustDetailPage screen="policy" />,
        },
        {
            frontend: 'view',
            path: 'fund-management/:trustId/gearing',
            element: <ViewFundTrustDetailPage screen="gearing" />,
        },
        {
            frontend: 'view',
            path: 'fund-management/:trustId/discount',
            element: <ViewFundTrustDetailPage screen="discount" />,
        },
        {
            frontend: 'view',
            path: 'fund-management/:trustId/register',
            element: <ViewFundTrustDetailPage screen="register" />,
        },
        {
            frontend: 'view',
            path: 'fund-management/:trustId/rns',
            element: <ViewFundTrustDetailPage screen="rns" />,
        },
        {
            frontend: 'view',
            path: 'fund-management/:trustId/aifmd',
            element: <ViewFundTrustDetailPage screen="aifmd" />,
        },
        {
            frontend: 'view',
            path: 'fund-management/:trustId/kid',
            element: <ViewFundTrustDetailPage screen="kid" />,
        },
        {
            frontend: 'view',
            path: 'fund-management/:trustId/board-pack',
            element: <ViewFundTrustDetailPage screen="board-pack" />,
        },
        {
            frontend: 'view',
            path: 'fund-management/:trustId/continuation',
            element: <ViewFundTrustDetailPage screen="continuation" />,
        },
        {
            frontend: 'view',
            path: 'fund-management/:trustId/research',
            element: <ViewFundTrustDetailPage screen="research" />,
        },
    ],
});
